export const TEXTO_BOTOES = {
  'EXCLUIR': 'excluir',
  'USAR_COMO_VIGENTE': 'Usar como cartão vigente'
}

export const MENSAGEM_VIGENTE = 'Cartão Vigente'
